export default {
  name: 'LotsModal',
  props: {
    alarmDescModalVisible: {
      type: Boolean,
      default: false
    },
    alarmDesc: {
      type: String,
      default: ''
    },
    close: {
      type: Function
    }
  },
  watch: {
    alarmDesc () {
      if (this.alarmDesc && this.alarmDesc.length > 0) {
        let temp = this.alarmDesc.split('/')
        let obj = {}
        temp.forEach(data => {
          const keyAndValue = data.split(':')
          const key = keyAndValue[0].trim()
          const value = keyAndValue[1].trim()
          obj[key] = value
        })
        this.initDatas(obj)
      }
    },
    alarmDescModalVisible () {
      this.modalVisible = this.alarmDescModalVisible
    }
  },
  methods: {
    initDatas (data) {
      this.eqpId = data['EQP ID']
      this.moduleId = data['MODULE ID']
      this.ruleNo = data['RULE NO']
      this.relatedValue = data['RELATED VALUE'].length > 0 ? data['RELATED VALUE'] : ''
    },
    resetModalData () {
      this.eqpId = null
      this.moduleId = null
      this.ruleNo = null
      this.relatedValue = null
    },
    closeModal () {
      this.resetModalData()
      this.close()
    }
  },
  data () {
    return {
      eqpId: null,
      moduleId: null,
      ruleNo: null,
      relatedValue: [],
      modalVisible: false
    }
  }
}
